import React, { Component } from 'react'

import { Modal, Tag } from 'antd'

import utils from '../../utils'
import fetch from './../fetch'


const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function () {
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

const getSelection = () => {
    return DataGrid.selections
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'orgName', label: '部门', width: 150},
    {key:'participantsNum', label: '参评人数(P)', width: 95},
    {key:'excellentNum', label: '优秀(A)', width: 95},
    {key:'goodNum', label: '良好(B)', width: 95},
    {key:'qualifiedNum', label: '合格(C)', width: 95},
    {key:'defaultQualifiedNum', label: 'N', width: 95},
    {key:'excellenceRate', label: 'A/P', width: 95},
    {key:'goodRate', label: 'B/P', width: 95},
    {key:'qualifiedRate', label: 'C/P', width: 95},
    {key:'defaultQualifiedRate', label: 'N/P', width: 95},
    { key: 'termName', label: '所属学年', width: 130 },
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('jxcp/summary/external/list', Object.assign(defaultsParams, keywords))
        .then(response => {
            return {
                data: response.payload.data,
                meta: response.payload.meta
            };
        })
        .then(response => (Object.assign({
            result: (response.data.dataList || []).map(item => {
                return Object.assign(item, {
                    backFlag: response.backFlag,
                })
            }),
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                Key: d.id,
                checked: false
            })),
            meta: response.meta,
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('jxcp/summary/external/insert', data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '提示信息!',
                    content: (
                        <div>
                            <p>{response.message}</p>
                        </div>
                    ),
                    onOk () {
                        DataGrid.selections = [];
                    },
                    okText: "确认",
                });
            }
            return response;
        });
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.post('jxcp/summary/external/get', id)
        .then(response => response.payload.data)
        .catch(error => {
            console.log('error');
        });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (data) => {
    return fetch.post('jxcp/summary/external/update', data)
        .then(response => {
            if (response.code === 200) {
                Modal.success({
                    title: '提示信息',
                    content: (
                        <div>
                            <p>{response.message}</p>
                        </div>
                    ),
                    okText: "确认",
                    onOk () {
                        DataGrid.selections = [];
                    },
                });
            }
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('jxcp/summary/external/remove', ids)
        .then(response => {
            return response;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.warn({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                if (callback) {
                                    callback()
                                }
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}
export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    getSelection,
    insert,
    querySearchById,
    update,
    remove,
    batchRemove
}